import React from 'react';
import {Button, Col, Container, Row} from 'reactstrap';
import CheckoutButton from 'components/CheckoutButton';
import CountdownTimer from '../CountdownTimer';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faLock, faCartPlus} from '@fortawesome/pro-light-svg-icons';
import './SalesCta.scss';
import classNames from 'classnames';
import TntgCountdownSection from 'components/TntgCountdownSection';
import {usePhaseState} from 'funnel-schedule/phase-context';

export function SecurityDisclaimer({iconColor = 'green', noGuaranteeText = false, className = undefined}) {
  return (
    <div className={classNames(`securityDisclaimer`, className)}>
      <img
        className={classNames(`securityDisclaimerImage`)}
        alt="payment types accepted graphic"
        src="https://cdn.foodrevolution.org/global/images/payments-accepted-20240424.svg"
        width={1800}
        height={175}
      />
      <div className={classNames(`disclaimer-copy`, `text-small`)}>
        <p className={classNames(noGuaranteeText ? 'mb-0' : 'mb-2')}>
          <FontAwesomeIcon
            className={classNames(`securityDisclaimerIcon`, `text-${iconColor}`, `me-1`)}
            //@ts-ignore
            icon={faLock}
          />{' '}
          For your security, all orders are processed on a secured server.
        </p>
        {noGuaranteeText ? null : (
          <p className="mb-0">Your purchase is protected by our 60-day money back guarantee.</p>
        )}
      </div>
    </div>
  );
}

export function TreesRow() {
  return (
    <Row className="d-flex align-items-center justify-content-center trees-for-future wrapper pb-0">
      <Col xs="12" md="10">
        <Row className="d-flex align-items-center justify-content-center">
          <Col xs="12" lg="8" className="mb-3 mb-lg-0">
            <h5 className="text-center text-lg-left text-condensed text-800 mb-0">
              For every Impact Kit purchased, we make a donation to Trees for the Future, enabling them to plant another
              organic fruit or nut tree in a low-income community.
            </h5>
          </Col>
          <Col xs="12" lg="4" className="text-center">
            <img className="logo-trees img-fluid" src="https://cdn.foodrevolution.org/global/trees-logo-color.png" />
          </Col>
        </Row>
      </Col>
    </Row>
  );
}

export default function CtaSales(props) {
  const offerBox = classNames(
    'offer-box offer-box-shadow px-3 py-4 px-sm-4 px-md-5 py-md-5 text-center',
    props.offerBoxBackground,
    props.offerBoxBorder,
    props.badges
  );

  const date = new Date(`${props.timerDate}`).getTime();

  return (
    <div className={classNames(`cta-sales cta-sales-${props.className}`)}>
      <Container>
        {props.bonus ? (
          <Row className="d-flex justify-content-center align-items-center wrapper pt-0">
            <Col xs="8" sm="5" lg="3" className="mb-3 mb-lg-0 p-0">
              <img className="img-fluid" src="https://cdn.foodrevolution.org/tntg/tntg-mockup-dvd.png" />
            </Col>
            <Col xs="12" sm="10" lg="7" className="text-center text-lg-left">
              <h3 className="text-condensed text-uppercase mb-2">Special Bonus Offer</h3>
              <p>
                For a limited time only we’ll ship you a physical DVD that you can watch any time, and share with
                friends and loved ones, too! Buy today and the DVD can be added to your order for NO extra charge!
              </p>
            </Col>
          </Row>
        ) : null}
        <Row className="d-flex justify-content-center">
          <Col xs="12">
            <div className="offer-box offer-box-shadow px-3 py-4 px-sm-4 px-md-5 py-md-5 text-center background-white border-dashed border-green border-5 rounded">
              <div className="offer-box-inner">
                <Container fluid>
                  <Row className="d-flex justify-content-center">
                    <Col className="text-center">
                      {props.lastChance ? (
                        <>
                          <h4 className="offer-box-heading-last-chance">{props.lastChance}</h4>
                          <h3 className="offer-box-heading text-condensed text-800 mx-auto">{props.heading}</h3>
                        </>
                      ) : (
                        <>{props.heading ? <div className="offer-box-heading">{props.heading}</div> : null}</>
                      )}

                      <Row className="d-flex justify-content-center mb-2">
                        <Col xs="12" lg="8">
                          <img
                            className="img-fluid"
                            src="https://cdn.foodrevolution.org/tntg/tntg-productimage-digitalall.png"
                          />
                        </Col>
                      </Row>

                      {props.offerPrice ? (
                        <>
                          <h3 className="offer-box-regular-price text-400 mb-2">
                            Regular Price: <del>${props.regularPrice}</del>
                          </h3>
                          <h2 className="offer-box-offer-text text-condensed text-800 text-green mx-auto mb-3">
                            {props.offerText} ${props.offerPrice}
                          </h2>
                        </>
                      ) : (
                        <h1 className="offer-box-regular-price text-condensed text-800 text-green mt-3 mb-2">
                          Your Price: ${props.regularPrice}
                        </h1>
                      )}

                      <CheckoutButton
                        btnstyle="offer-box-button"
                        sku={props.sku}
                        price={props.offerPrice}
                        slug={props.slug}
                      >
                        <FontAwesomeIcon className="mr-2" icon={faCartPlus} /> Buy Now
                      </CheckoutButton>
                    </Col>
                  </Row>

                  {props.timer ? (
                    props.salesTimerScreening ? (
                      <TntgCountdownSection salesTimerScreening stacked />
                    ) : (
                      <TntgCountdownSection sales stacked />
                    )
                  ) : null}

                  {props.specialTimer ? (
                    <>
                      <div className="offer-box-timer">
                        <h3 className="offer-box-timer-text text-condensed text-800 mb-2 mt-4">{props.timerText}</h3>
                        <div className="countdown-dark">
                          <CountdownTimer time={props.timerDate} />
                        </div>
                      </div>
                    </>
                  ) : null}

                  {props.bonusOffer ? props.bonusOffer : null}

                  <div className="offer-box-details">
                    <div className="offer-box-cards">
                      <img
                        className="img-fluid img-cc"
                        src="https://cdn.foodrevolution.org/global/images/payments-accepted-20240424.svg"
                        width={1800}
                        height={175}
                      />
                    </div>
                    <div className="offer-box-security">
                      <FontAwesomeIcon className="offer-box-security-icon mr-2" icon={faLock} />
                      For your security, all orders are processed on a secured server.
                    </div>
                    <div className="offer-box-protected d-flex justify-content-center">
                      Your purchase is protected by our 60-day money back guarantee.
                    </div>
                  </div>
                </Container>
              </div>
            </div>
          </Col>
        </Row>
        {props.trees ? (
          <Row className="d-flex align-items-center justify-content-center trees-for-future wrapper pb-0">
            <Col xs="12" md="10">
              <Row className="d-flex align-items-center justify-content-center">
                <Col xs="12" lg="8" className="mb-3 mb-lg-0">
                  <h5 className="text-center text-lg-left text-condensed text-800 mb-0">
                    For every Impact Kit purchased, we make a donation to Trees for the Future, enabling them to plant
                    another organic fruit or nut tree in a low-income community.
                  </h5>
                </Col>
                <Col xs="12" lg="4" className="text-center">
                  <img
                    className="logo-trees img-fluid"
                    src="https://cdn.foodrevolution.org/global/trees-logo-color.png"
                  />
                </Col>
              </Row>
            </Col>
          </Row>
        ) : null}
      </Container>
    </div>
  );
}

export function SalesCta67Premiere(props) {
  return (
    <CtaSales
      className="offer-67"
      regularPrice="197"
      offerPrice="67"
      heading="By taking action to own the Impact Kit, TODAY ONLY, you’ll receive over 65% off the regular price of $197"
      offerText="Special World Premiere Screening Page Price:"
      sku="tntg"
      slug="tntg-impactkit-special-wlc-30daytrial-st"
      timerText="Your over 65% world premiere discount expires in:"
      timerDate="2019-10-16T23:59:00-07:00"
      {...props}
    />
  );
}

export function SalesCta67(props) {
  return (
    <CtaSales
      className="offer-67"
      regularPrice="197"
      offerPrice="67"
      heading={
        <h3>
          By taking action NOW, <br className="d-none d-sm-block d-lg-none" />
          you’ll receive over <br className="d-none d-xl-block" />
          65% <br className="d-none d-sm-block d-lg-none" />
          off the full price of $197
        </h3>
      }
      offerText={
        <>
          Special Price Only On <br className="d-none d-lg-block d-xl-none" />
          This Page:
        </>
      }
      bonusOffer={
        <h4 className="text-condensed text-800 mt-4">
          PLUS Get A Treasured <br className="d-none d-md-block d-lg-none" />
          Health Collection <br className="d-none d-lg-block" />
          ($97 Value!) Completely FREE
        </h4>
      }
      sku="tntg"
      slug="tntg-impactkit-special-wlc-30daytrial-st"
      timer
      salesTimerScreening
      {...props}
    />
  );
}

export function SalesCtaScreeningFull(props) {
  return (
    <CtaSales
      className="offer-67"
      regularPrice="197"
      offerPrice="67"
      heading={
        <h3>
          By taking action NOW, <br className="d-none d-sm-block d-lg-none" />
          you’ll receive over <br className="d-none d-xl-block" />
          65% <br className="d-none d-sm-block d-lg-none" />
          off the full price of $197
        </h3>
      }
      offerText={
        <>
          Special Price Only On <br className="d-none d-lg-block d-xl-none" />
          This Page:
        </>
      }
      bonusOffer={
        <h4 className="text-condensed text-800 mt-4">
          PLUS Get A Treasured <br className="d-none d-md-block d-lg-none" />
          Health Collection <br className="d-none d-lg-block" />
          ($97 Value!) Completely FREE
        </h4>
      }
      sku="tntg"
      slug="tntg-impactkit-special-wlc-30daytrial-st"
      {...props}
    />
  );
}

export function SalesCta67NoDvd(props) {
  return (
    <CtaSales
      className="offer-67"
      regularPrice="197"
      offerPrice="67"
      heading="By taking action to own the Impact Kit, TODAY ONLY, you’ll receive over 65% off the regular price of $197"
      offerText="Special Limited Time Screening Page Price:"
      sku="tntg"
      slug="tntg-impactkit-special-3"
      timer
      {...props}
    />
  );
}

export function SalesCta97Premiere(props) {
  return (
    <CtaSales
      className="offer-97"
      regularPrice="197"
      offerPrice="97"
      heading="Support our mission, and your health, with lifetime access to the Impact Kit today!"
      offerText="Special World Premiere Price:"
      sku="tntg"
      slug="tntg-impactkit-launch-wlc-30daytrial-st"
      timerText="Your 50% world premiere discount expires in:"
      timerDate="2019-10-16T23:59:00-07:00"
      {...props}
    />
  );
}

export function SalesCta97(props) {
  return (
    <CtaSales
      className="offer-97"
      regularPrice="197"
      offerPrice="97"
      heading={
        <h3>
          Support this urgent mission <br className="d-none d-xl-block" />
          and your health with the Impact Kit!
        </h3>
      }
      offerText="Limited Time Discount Price:"
      sku="tntg"
      slug="tntg-impactkit-launch-wlc-30daytrial-st"
      timer
      {...props}
    />
  );
}

export function SalesCta97Standalone(props) {
  return (
    <CtaSales
      className="offer-97"
      regularPrice="197"
      offerPrice="97"
      heading={
        <h3>
          Support this urgent mission <br className="d-none d-xl-block" />
          and your health with the Impact Kit!
        </h3>
      }
      offerText="Your Special Offer:"
      sku="tntg"
      slug="tntg-impactkit-launch-wlc-30daytrial-st"
      bonusOffer={
        <h4 className="text-condensed text-800 mt-4">
          PLUS Get A Treasured <br className="d-none d-md-block d-lg-none" />
          Health Collection <br className="d-none d-lg-block" />
          ($97 Value!) Completely FREE
        </h4>
      }
      {...props}
    />
  );
}

export function SalesCta67Standalone(props) {
  return (
    <CtaSales
      className="offer-67"
      regularPrice="197"
      offerPrice="67"
      heading="Support our mission, and your health, with lifetime access to the Impact Kit today!"
      offerText="Your Special Offer:"
      sku="tntg"
      slug="tntg-impactkit-special-wlc-30daytrial-st"
      bonusOffer={
        <h4 className="text-condensed text-800 mt-4">
          PLUS Get A Treasured <br className="d-none d-md-block d-lg-none" />
          Health Collection <br className="d-none d-lg-block" />
          ($97 Value!) Completely FREE
        </h4>
      }
      {...props}
    />
  );
}

export function SalesCta197(props) {
  return (
    <CtaSales
      className="offer-197"
      regularPrice="197"
      heading="Support our mission, and your health, with lifetime access to the Impact Kit today!"
      sku="tntg"
      slug="tntg-impactkit-wlc-30daytrial-st"
      {...props}
    />
  );
}

export function SalesCtaImpactDynamic(props) {
  const {
    phases: {webinar: {phase = 'after'} = {}}
  } = usePhaseState();
  const opts =
    phase === 'replay'
      ? {
          className: 'offer-97',
          offerPrice: '97',
          offerText: 'Limited Time Discount Price:',
          slug: 'tntg-impactkit-launch-wlc-30daytrial-st',
          timer: true,
          bonus: props.showBonus
        }
      : {className: 'offer-197', slug: 'tntg-impactkit-wlc-30daytrial-st'};
  return (
    <CtaSales
      regularPrice="197"
      heading={
        <h3>
          Support this urgent mission <br className="d-none d-xl-block" />
          and your health with the Impact Kit!
        </h3>
      }
      sku="tntg"
      {...props}
      {...opts}
      bonusOffer={
        <h4 className="text-condensed text-800 mt-4">
          PLUS Get A Treasured <br className="d-none d-md-block d-lg-none" />
          Health Collection <br className="d-none d-lg-block" />
          ($97 Value!) Completely FREE
        </h4>
      }
    />
  );
}

export function SalesCtaImpactDynamicNoDvd(props) {
  const {
    phases: {webinar: {phase = 'after'} = {}}
  } = usePhaseState();
  const opts =
    phase === 'replay'
      ? {
          className: 'offer-97',
          offerPrice: '97',
          offerText: 'Limited Time Discount Price:',
          slug: 'tntg-impactkit-launch-2',
          timer: true,
          bonus: props.showBonus
        }
      : {className: 'offer-197', slug: 'tntg-impactkit-2'};
  return (
    <CtaSales
      regularPrice="197"
      heading="Support our mission, and your health, with lifetime access to the Impact Kit today!"
      sku="tntg"
      {...props}
      {...opts}
    />
  );
}

export function UpsellSales(props) {
  const offerBox = classNames(
    'offer-box text-center',
    props.offerBoxPadding,
    props.offerBoxBackground,
    props.offerBoxBorder
  );

  return (
    <div className={classNames(`cta-sales cta-sales-${props.className}`)}>
      <div className={offerBox}>
        {props.heading ? <div className="upsell-box-heading">{props.heading}</div> : null}

        <div className="upsell-box-confirm">
          <div className="mb-3">
            <CheckoutButton
              className="offer-box-button offer-box-button-upsell"
              sku={props.sku}
              price={props.offerPrice}
              slug={props.slug}
            >
              <FontAwesomeIcon className="mr-2" icon={faCartPlus} /> Yes, Add to Order
            </CheckoutButton>
          </div>
          {props.text ? <div className="upsell-box-text">{props.text}</div> : null}
        </div>

        <div className="upsell-box-no">
          <div className="mb-3">
            <Button className="btn-upsell-gray">No, thanks.</Button>
          </div>
          <div className="upsell-box-no-text">
            Clicking the “No” button above will take you to the products you just got.
          </div>
        </div>

        <div className="offer-box-details">
          <div className="offer-box-cards">
            <img
              className="img-fluid img-cc"
              src="https://cdn.foodrevolution.org/global/images/payments-accepted-20240424.svg"
              width={1800}
              height={175}
            />
          </div>
          <div className="offer-box-security">
            <FontAwesomeIcon className="offer-box-security-icon mr-2" icon={faLock} />
            For your security, all orders are processed on a secured server.
          </div>
          <div className="offer-box-protected d-flex justify-content-center">
            Your purchase is protected by our 60-day money back guarantee.
          </div>
        </div>
      </div>

      {props.noTrees ? null : (
        <Row className="trees-for-future text-white d-flex align-items-center justify-content-center mt-5">
          <Col xs="11" lg="8" className="mb-4 mb-lg-0">
            <h6 className="section-only-heading text-center text-lg-left text-400">
              For every new order, we make a donation to Trees for the Future, enabling them to plant another organic
              fruit or nut tree in a low-income community.
            </h6>
          </Col>
          <Col xs="11" lg="3" className="text-center">
            <img className="logo-trees" src="https://cdn.foodrevolution.org/global/trees-logo-white.png" />
          </Col>
        </Row>
      )}
    </div>
  );
}

UpsellSales.defaultProps = {
  offerBoxBackground: 'background-white',
  offerBoxBorder: 'border-dashed border-green border-2 offer-box-shadow',
  offerBoxPadding: 'px-3 py-4 px-sm-4 px-md-5 py-md-5'
};

export function WlcUpsell(props) {
  return (
    <UpsellSales
      className="offer-wlc"
      heading="One-Time Offer Only!"
      text="Clicking the button above will sign you up for WHOLE Life Club for a free 3-month trial. After 3 months, you’ll be auto-billed at the $19/month discounted rate."
      sku="frs"
      slug="frs21-wlc-us"
      {...props}
    />
  );
}
